<app-header></app-header>

<app-admin-menu-sidebar class="sidebar-dark-primary"></app-admin-menu-sidebar>

<div class="content-wrapper">
    <div class="container-fluid">
        <div class="main notification">
            <div class="main-title">
                <h1>User List</h1>
            </div>
            <!-- <div *ngFor="let notification of notifications" class="notification-item-list row"
                [ngClass]="{ 'active-notification': notification.isActive, 'inactive-notification': !notification.isActive }">
                <div class="col-md-1 text-left">
                    <span class="active-dot" *ngIf="notification.isActive">
                        <i class="fas fa-circle"></i>
                    </span></div>
                <div class="col-md-9"><span>{{ notification.message }}</span></div>
                <div class="col-md-2 text-right"><span>{{ notification.time }}</span></div>
                <hr />
            </div> -->

            <p-table
                [value]="data"
                responsiveLayout="scroll"
                [loading]="loading"
                class="small-table"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th>Farm Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Domain Name</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>{{ item.name }}</td>
                        <td>{{ item.farmName }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.phone }}</td>
                        <td>{{ item.domainName }}</td>
                        <td class="text-right">
                            <a
                                (click)="detailNotification(item.id)"
                                pTooltip="Notification Detail"
                                tooltipPosition="top"
                                class="btn btn-primary"
                                >Detail</a
                            >
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <p-paginator
                [rows]="pageSize"
                [totalRecords]="totalRecords"
                (onPageChange)="onPageChange($event)"
            ></p-paginator>
        </div>
        <p-dialog
            [(visible)]="displayDetailBox"
            modal="true"
            [style]="{width: '600px'}"
            [closable]="false"
        >
            <h5 class="mb-4">Teanant Detail</h5>
            <ng-template pTemplate="content">
                <div class="text-left notification-detail">
                    <table class="table">
                        <tr>
                            <td>Name:-</td>
                            <td>{{ tenantDetail?.name }}</td>
                        </tr>
                        <tr>
                            <td>Farm Name:-</td>
                            <td>{{ tenantDetail?.farmName }}</td>
                        </tr>
                        <tr>
                            <td>Email:-</td>
                            <td>{{ tenantDetail?.email }}</td>
                        </tr>
                        <tr>
                            <td>Phone:-</td>
                            <td>{{ tenantDetail?.phone }}</td>
                        </tr>
                        <tr>
                            <td>Domain:-</td>
                            <td>{{ tenantDetail?.domainName }}</td>
                        </tr>
                    </table>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button
                    class="btn btn-primary mr-2"
                    *ngIf="!tenantDetail?.isActivate"
                    (click)="activateTenant(tenantDetail)"
                >
                    Activate
                </button>
                <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="closePopup()"
                >
                    Close
                </button>
            </ng-template>
        </p-dialog>
    </div>
</div>

<app-footer></app-footer>
<app-control-sidebar></app-control-sidebar>
<div id="sidebar-overlay" (click)="onToggleMenuSidebar()"></div>
